import { get, postGeneric, deleteGeneric } from '../../common/constants'

const BASE = 'order/serviceability/intel'

const cleanParams = (params) => {
  const out = {}
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== null && v !== undefined && v !== '') out[k] = v
  })
  return out
}

export const intelApi = {
  trendsOverview: (params) => get(`${BASE}/trends/overview`, cleanParams(params)),
  trendsCuts: (params) => get(`${BASE}/trends/cuts`, cleanParams(params)),
  coverageDelivery: (params) => get(`${BASE}/coverage/delivery`, cleanParams(params)),
  coveragePickup: (params) => get(`${BASE}/coverage/pickup`, cleanParams(params)),
  coverageUploads: (params) => get(`${BASE}/coverage/uploads`, cleanParams(params)),
  coverageUploadsPincodeEvents: (params) => get(`${BASE}/coverage/uploads/pincode-events`, cleanParams(params)),
  coveragePincodeLookup: (params) => get(`${BASE}/coverage/pincode-lookup`, cleanParams(params)),
  weights: (params) => get(`${BASE}/weights`, cleanParams(params)),
  setupGroups: () => get(`${BASE}/setup/groups`),
  serviceTypes: (params) => get(`${BASE}/service-types`, cleanParams(params)),
  serviceTypePerformance: (params) => get(`${BASE}/servicetype/performance`, cleanParams(params)),
  // Dropdown lookups. formOptions returns parentCps + serviceTypes (+ enum lists) in one call;
  // accountCodes is cascading — pass the chosen parent_cp to scope the courier-code list.
  formOptions: () => get(`${BASE}/form-options`),
  accountCodes: (params) => get('order/serviceability/account-codes', cleanParams(params)),
  // Block Pincodes — create (courier OR merchant scoped), list active, unblock by meta id.
  blockCreate: (data) => postGeneric(`${BASE}/block`, data),
  blockActive: (params) => get(`${BASE}/block/active`, cleanParams(params)),
  blockUnblock: (id) => deleteGeneric(`${BASE}/block/${id}`),
  // Bulk unblock — clears all meta ids in a grouped row (platform-wide fan-out) in one call.
  blockUnblockBulk: (ids) => postGeneric(`${BASE}/block/unblock`, { ids }),
  blockRto: (params) => get(`${BASE}/block/rto`, cleanParams(params)),
  stuckOrders: (params) => get(`${BASE}/stuck-orders`, cleanParams(params)),
  resolutionPlan: (params) => get(`${BASE}/stuck-orders/resolution`, cleanParams(params)),
  resolutionAlternatives: (params) => get(`${BASE}/stuck-orders/resolution/alternatives`, cleanParams(params)),
  dashboard: () => get(`${BASE}/dashboard`),
  nonServiceable: (params) => get(`${BASE}/coverage/non-serviceable`, cleanParams(params)),
  nonServiceableClients: (params) => get(`${BASE}/coverage/non-serviceable/clients`, cleanParams(params)),
  nonServiceableOrders: (params) => get(`${BASE}/coverage/non-serviceable/orders`, cleanParams(params)),
  coverageAnalysis: (params) => get(`${BASE}/coverage/analysis`, cleanParams(params)),
  coverageOrderStats: (params) => get(`${BASE}/coverage/analysis/orders`, cleanParams(params)),
  coverageOverview: (params) => get(`${BASE}/coverage/analysis/overview`, cleanParams(params)),
  coverageHistory: (params) => get(`${BASE}/coverage/analysis/history`, cleanParams(params)),
  stuckTrends: (params) => get(`${BASE}/stuck-orders/trends`, cleanParams(params)),
  // Block reasons come from reason_master (category PINCODE_BLOCK), not a hardcoded enum.
  blockReasons: () => get('reason-master', { category: 'PINCODE_BLOCK', activeOnly: true }),
}

export default intelApi
